export default {
    Tutorial: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "tutorial"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Tutorial.js
// module id = lHj8
// module chunks = 18